module.exports = __webpack_public_path__ + "static/podcast1-79b1adebf041ee632c4c6aeb8e6e57d6.jpg";